import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    redirect:'/home'
  },
  {
    path: '/home',
    component: () => import('../views/home/home.vue'),
    children:[
      {
        path:'/home',
        redirect:'/homePage'
      },
      {
        path:'/homePage',
        component:()=>import('@/views/homePage/homePage.vue')
      },
      {
        path:'/zhichi',
        component:()=>import('@/views/zhichi/Zhichi.vue'),
        children:[
          {
            path:'/zhichi',
            redirect:'/huduan'
          },
          {
            path:'/huduan',
            component:()=>import('@/views/huduan/Huduan.vue')
          },
		  {
            path:'/sdk',
            component:()=>import('@/views/sdk/sdk.vue')
          },
          {
            path:'/rooms',
            component:()=>import('@/views/rooms/Rooms.vue')
          },
          {
            path:'/service',
            component:()=>import('@/views/service/Service.vue')
          }
        ]
      },
      {
        path:'/about',
        component:()=>import('@/views/about/about.vue')
      },
      {
        path:'/product',
        component:()=>import('@/views/product/product.vue'),
        children:[
          {
            path:'/product',
            redirect:'/train'
          },
          {
            path:'/consultation',
            component:()=>import('@/views/consultation/consultation.vue')
          },
          {
            path:'/ultrasonic',
            component:()=>import('@/views/ultrasonic/ultrasonic.vue')
          },
          {
            path:'/rounds',
            component:()=>import('@/views/rounds/rounds.vue')
          },
          {
            path:'/door',
            component:()=>import('@/views/door/door.vue')
          },
          {
            path:'/referral',
            component:()=>import('@/views/referral/referral.vue')
          },
          {
            path:'/train',
            component:()=>import('@/views/train/train.vue')
          },
          {
            path:'/teaching',
            component:()=>import('@/views/teaching/teaching.vue')
          },
          {
            path:'/shipinsdk',
            component:()=>import('@/views/shipinsdk/Shipinsdk.vue')
          },
          {
            path:'/guochanhua',
            component:()=>import('@/views/guochanhua/Guochanhua.vue')
          },
          {
            path:'/zhineng',
            component:()=>import('@/views/zhineng/Zhineng.vue')
          },
          {
            path:'/visit',
            component:()=>import('@/views/visit/visit.vue')
          },
          {
            path:'/meet',
            component:()=>import('@/views/meet/meet.vue')
          },
          {
            path:'/save',
            component:()=>import('@/views/save/save.vue')
          }
        ]
      },
      {
        path:'/programme',
        component:()=>import('@/views/programme/programme.vue'),
        children:[
          {
            path:'/programme',
            redirect:'/county'
          },
          {
            path:'/county',
            component:()=>import('@/views/county/county.vue')
          },
          {
            path:'/conjoined',
            component:()=>import('@/views/conjoined/conjoined.vue')
          },
          {
            path:'/union',
            component:()=>import('@/views/union/union.vue')
          },
          {
            path:'/coordination',
            component:()=>import('@/views/coordination/coordination.vue')
          }
        ]
      }
    ]
  }
]

const router = new VueRouter({
  routes
})

export default router
